export default function SwapBoxLineIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="#F7F7F7" />
      <path
        d="M4.8 5.70002V18.3H19.2V5.70002H4.8ZM3.9 3.90002H20.1C20.3387 3.90002 20.5676 3.99485 20.7364 4.16363C20.9052 4.33241 21 4.56133 21 4.80002V19.2C21 19.4387 20.9052 19.6676 20.7364 19.8364C20.5676 20.0052 20.3387 20.1 20.1 20.1H3.9C3.66131 20.1 3.43239 20.0052 3.2636 19.8364C3.09482 19.6676 3 19.4387 3 19.2V4.80002C3 4.56133 3.09482 4.33241 3.2636 4.16363C3.43239 3.99485 3.66131 3.90002 3.9 3.90002ZM14.7 7.50002L17.85 10.2L14.7 12.9V11.1H11.1V9.30002H14.7V7.50002ZM9.3 16.5L6.15 13.8L9.3 11.1V12.9H12.9V14.7H9.3V16.5Z"
        fill="#4F90F3"
      />
    </svg>
  );
}
